(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1552],{

/***/ 31552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FivaFooter_FivaFooter; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/_Footer/FivaFooter/FivaFooter.module.css
var FivaFooter_module = __webpack_require__(39970);
var FivaFooter_module_default = /*#__PURE__*/__webpack_require__.n(FivaFooter_module);
// EXTERNAL MODULE: ./node_modules/antd/es/avatar/index.js + 4 modules
var avatar = __webpack_require__(7134);
// EXTERNAL MODULE: ./constants/SocialMediaLinks.ts
var SocialMediaLinks = __webpack_require__(80179);
;// CONCATENATED MODULE: ./components/SocialMediaIcons/DarkSocialMediaIcons.tsx




var DarkSocialMediaIcons = function() {
    var LINK_DIN = SocialMediaLinks/* SocialMediaLinks.LINK_DIN */.$.LINK_DIN, YOU_TUBE = SocialMediaLinks/* SocialMediaLinks.YOU_TUBE */.$.YOU_TUBE, TWITTER = SocialMediaLinks/* SocialMediaLinks.TWITTER */.$.TWITTER, INSTAGRAM = SocialMediaLinks/* SocialMediaLinks.INSTAGRAM */.$.INSTAGRAM, FACEBOOK = SocialMediaLinks/* SocialMediaLinks.FACEBOOK */.$.FACEBOOK;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            display: "flex",
            flexWrap: "wrap",
            gap: "0.3rem",
            paddingTop: "1rem"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                style: {
                    paddingTop: "4%",
                    marginRight: "1rem"
                },
                children: "S\xedguenos"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "0.3rem",
                    paddingTop: "1rem"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: FACEBOOK,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* default */.C, {
                            size: "large",
                            style: {
                                backgroundColor: "var(--fiva-color)",
                                color: "#FFFFFF",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                cursor: "pointer"
                            },
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/icons/media/facebook.svg",
                                alt: "Facebook logo"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: LINK_DIN,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* default */.C, {
                            size: "large",
                            style: {
                                backgroundColor: "var(--fiva-color)",
                                color: "#FFFFFF",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                cursor: "pointer"
                            },
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/icons/media/linkedin.svg",
                                alt: "LinkedIn logo"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: TWITTER,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* default */.C, {
                            size: "large",
                            style: {
                                backgroundColor: "var(--fiva-color)",
                                color: "#FFFFFF",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                cursor: "pointer",
                                padding: "8px"
                            },
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/icons/media/x-twitter.svg",
                                alt: "Twitter logo"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: INSTAGRAM,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* default */.C, {
                            size: "large",
                            style: {
                                backgroundColor: "var(--fiva-color)",
                                color: "#FFFFFF",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                cursor: "pointer"
                            },
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/icons/media/pinterest.svg",
                                alt: "Instagram logo"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: YOU_TUBE,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* default */.C, {
                            size: "large",
                            style: {
                                backgroundColor: "var(--fiva-color)",
                                color: "#FFFFFF",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                cursor: "pointer"
                            },
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/icons/media/youtube.svg",
                                alt: "YouTube logo"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var SocialMediaIcons_DarkSocialMediaIcons = (DarkSocialMediaIcons);

// EXTERNAL MODULE: ./node_modules/react-icons/md/index.mjs
var md = __webpack_require__(30080);
// EXTERNAL MODULE: ./constants/_pages.ts
var _pages = __webpack_require__(17179);
;// CONCATENATED MODULE: ./components/_Footer/FivaFooter/FivaFooter.tsx











var LOGO = "/Images/FivaIcon.svg";
var FivaFooter = function(param) {
    var _blue = param.blue, blue = _blue === void 0 ? true : _blue;
    var backgroundColor = blue ? {
        backgroundColor: "var(--fiva-secondary-color, #ddfffd)"
    } : {
        background: "linear-gradient(to bottom,white 15%,var(--Azul-claro, #ddfffd) 80%)"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        style: (0,_object_spread/* default */.Z)({
            margin: "0",
            padding: "4.5rem 1rem 1rem 1rem",
            color: "var(--Morado-Fiva, #401C72)"
        }, backgroundColor),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            fluid: true,
            className: (FivaFooter_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        xs: {
                            span: 12
                        },
                        md: {
                            span: 6,
                            offset: 1
                        },
                        lg: {
                            span: 7,
                            offset: 1
                        },
                        xl: {
                            span: 7,
                            offset: 1
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                display: "flex",
                                justifyContent: "start",
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: LOGO,
                                        alt: "Fiva Logo",
                                        width: 160,
                                        height: 95
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/Images/enisa.png",
                                    alt: "Certificado Enisa",
                                    width: 140,
                                    height: 140
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                    style: {
                        fontSize: "0.8em"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                            xs: {
                                span: 12
                            },
                            md: {
                                span: 9,
                                offset: 1
                            },
                            lg: {
                                span: 9,
                                offset: 1
                            },
                            xl: {
                                span: 2,
                                offset: 1
                            },
                            style: {
                                marginBottom: "4%"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "En Fiva nos comprometemos a reducir la factura de nuestros clientes aport\xe1ndoles los mejores servicios y productos. En Fiva tenemos el comparador de tarifas de luz m\xe1s preciso del mercado."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xs: {
                                        span: 12
                                    },
                                    md: {
                                        span: 12
                                    },
                                    lg: {
                                        span: 12
                                    },
                                    xl: {
                                        span: 12
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialMediaIcons_DarkSocialMediaIcons, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                            xs: {
                                span: 12
                            },
                            md: {
                                span: 3,
                                offset: 1
                            },
                            lg: {
                                span: 3,
                                offset: 1
                            },
                            xl: {
                                span: 2,
                                offset: 1
                            },
                            style: {
                                marginBottom: "3%"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    children: "Servicios"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Comparativa y contrataci\xf3n"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Ajuste de optimizaci\xf3n de potencia"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Estudios de eficiencia energ\xe9tica"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Transici\xf3n a energ\xeda renovable"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Soluciones de software"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                            xs: {
                                span: 12
                            },
                            md: {
                                span: 3,
                                offset: 1
                            },
                            lg: {
                                span: 3,
                                offset: 1
                            },
                            xl: {
                                span: 2,
                                offset: 1
                            },
                            className: (FivaFooter_module_default()).linkContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    children: "Fiva"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: _pages/* Pages.energy */.i.energy,
                                        children: "Eficiencia energ\xe9tica"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/solar",
                                        children: "Autoconsumo"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/blog",
                                        children: "Blog"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/contacto",
                                        children: "Contacto"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/sube-tu-factura",
                                        children: "Comparador"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                            xs: {
                                span: 12
                            },
                            md: {
                                span: 4
                            },
                            lg: {
                                span: 3
                            },
                            xl: {
                                span: 3
                            },
                            style: {
                                marginBottom: "3%"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    children: "Contacto"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "mailto:contacto@fiva.es",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(md/* MdEmail */.ixJ, {
                                                style: {
                                                    marginRight: "8px",
                                                    verticalAlign: "middle",
                                                    fontSize: "1rem"
                                                }
                                            }),
                                            "contacto@fiva.es"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "tel:+34 624 64 41 37",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(md/* MdPhone */.IXo, {
                                                style: {
                                                    marginRight: "8px",
                                                    verticalAlign: "middle",
                                                    fontSize: "1rem"
                                                }
                                            }),
                                            "624 64 41 37"
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                    style: {
                        justifyContent: "space-between"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xs: {
                                span: 12
                            },
                            md: {
                                span: 5,
                                offset: 1
                            },
                            lg: {
                                span: 7,
                                offset: 1
                            },
                            xl: {
                                span: 7,
                                offset: 1
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    gap: "5%",
                                    alignItems: "center",
                                    marginBottom: "3%"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "\xa92024 fiva."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            gap: "5%",
                                            alignItems: "center"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "https://res.cloudinary.com/dzzkeb6xp/image/upload/v1684617444/spain_pw44lf.png",
                                                alt: "Spain icons",
                                                width: 40
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                style: {
                                                    paddingTop: "13%"
                                                },
                                                children: "Espa\xf1ol"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xs: {
                                span: 12
                            },
                            md: {
                                span: 6
                            },
                            lg: {
                                span: 4
                            },
                            xl: {
                                span: 4
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (FivaFooter_module_default()).policy,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/privacy",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "T\xe9rminos de Servicio |"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/privacy",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Pol\xedtica de Privacidad |"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/cookies",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Pol\xedtica de Cookies"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var FivaFooter_FivaFooter = (FivaFooter);


/***/ }),

/***/ 80179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ SocialMediaLinks; }
/* harmony export */ });
var SocialMediaLinks = {
    LINK_DIN: "https://www.linkedin.com/company/fiva-e-s/",
    YOU_TUBE: "https://www.youtube.com/channel/UCruDEBFItmXrN14XxbVOdOQ",
    TWITTER: "https://twitter.com/FivaEnergy",
    INSTAGRAM: "https://www.instagram.com/fiva.es/",
    FACEBOOK: "https://www.facebook.com/profile.php?id=61550677975264"
};


/***/ }),

/***/ 17179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ Pages; }
/* harmony export */ });
var Pages = {
    energy: "/eficiencia-energetica",
    contact: "contacto"
};


/***/ }),

/***/ 39970:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"linkContainer":"FivaFooter_linkContainer__8DQkY","policy":"FivaFooter_policy__woqYS","container":"FivaFooter_container__O3WvG"};

/***/ })

}]);